import React from 'react';
import { Button } from '@umu/umu-design';
import { lang } from '@umu/ukit-lang';
import { IMemberInfo } from '../../interface';
import MemberItemInfo from './membernfo';
import './index.scss';
import { components } from 'common';
import { classSet } from '@umu/umu-dom';
interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    maxWidth: number;
    selectList?: IMemberInfo[];
    onSubmit?: () => void;
    onItemDelete: (item: IMemberInfo) => void;
}
const { If } = components;

function MemberFooter(props: IProps) {
    const { className = '', maxWidth, selectList = [], onItemDelete, onSubmit, ...rest } = props;
    const renderSelectList = () => {
        return selectList.map((item) => {
            return (
                <MemberItemInfo
                    key={`${item.id}-member-info`}
                    style={{
                        width: maxWidth - 24,
                    }}
                    info={item}
                    onDelete={onItemDelete}
                />
            );
        });
    };
    return (
        <div className={classSet({
            'knowledge-member-search-footer': true,
            [className]: true,
            'knowledge-member-search-footer-has-member': selectList.length > 0,
        })} {...rest}>
            <If condition={selectList.length > 0}>
                <div className="member-search-list">{renderSelectList()}</div>
            </If>
            <Button className="submit-btn" type="primary" disabled={selectList.length <= 0} onClick={onSubmit}>
                {lang('确认选择')}
            </Button>
        </div>
    );
}

export default MemberFooter;
